export const AUTH_CONFIG = {
  clientId: import.meta.env.VITE_AUTH_CLIENT_ID || 'your-client-id-here',
  tenantId: import.meta.env.VITE_AUTH_TENANT_ID || 'your-tenant-id-here',
  
  authority: `https://login.microsoftonline.com/${import.meta.env.VITE_AUTH_TENANT_ID || 'your-tenant-id-here'}`,
  
  redirectUri: import.meta.env.VITE_AUTH_REDIRECT_URI || 
    (import.meta.env.DEV ? 'http://localhost:5173/auth/callback' : `${typeof window !== 'undefined' ? window.location.origin : ''}/auth/callback`),
  
  postLogoutRedirectUri: import.meta.env.VITE_AUTH_LOGOUT_URI || (typeof window !== 'undefined' ? window.location.origin : ''),
  
  scopes: [
    'openid',
    'profile',
    'email',
    'offline_access',
  ],
  
  apiScope: import.meta.env.VITE_API_SCOPE || null,
};

export const AUTH_ENDPOINTS = {
  authorize: `${AUTH_CONFIG.authority}/oauth2/v2.0/authorize`,
  token: `${AUTH_CONFIG.authority}/oauth2/v2.0/token`,
  logout: `${AUTH_CONFIG.authority}/oauth2/v2.0/logout`,
};

export const AUTH_STORAGE_KEYS: Record<string, string> = {
  ACCESS_TOKEN: 'auth_token',
  REFRESH_TOKEN: 'refresh_token',
  ID_TOKEN: 'id_token',
  USER_INFO: 'user_info',
  TOKEN_EXPIRY: 'token_expiry',
  STATE: 'auth_state',
  NONCE: 'auth_nonce',
  CODE_VERIFIER: 'code_verifier',
};

export const generateState = (): string => {
  return btoa(Math.random().toString()).substring(10, 15);
};

export const generateNonce = (): string => {
  return btoa(Math.random().toString()).substring(10, 15);
};

export const generateCodeVerifier = (): string => {
  const array = new Uint8Array(32);
  crypto.getRandomValues(array);
  return btoa(String.fromCharCode.apply(null, Array.from(array)))
    .replace(/\+/g, '-')
    .replace(/\//g, '_')
    .replace(/=/g, '');
};

export const generateCodeChallenge = async (verifier: string): Promise<string> => {
  const encoder = new TextEncoder();
  const data = encoder.encode(verifier);
  const digest = await crypto.subtle.digest('SHA-256', data);
  return btoa(String.fromCharCode.apply(null, Array.from(new Uint8Array(digest))))
    .replace(/\+/g, '-')
    .replace(/\//g, '_')
    .replace(/=/g, '');
};
